module.exports = __webpack_public_path__ + "ZeroPercent-912678b1.webp";